module.exports = __webpack_public_path__ + "img/icon4.e9f61e58.png";